// extracted by mini-css-extract-plugin
module.exports = {"flightCardBadges":"FlightCardBadges-module__flightCardBadges___486K5"};